module.exports = __webpack_public_path__ + "img/z-logo-sm-white.8e3d7b8a.svg";